export const CONSTANTS = {
  notAuthorized: 141,
  errorToken: 142,
  expiredAccessToken: 143,
  errorValidationRole: 132,
  code: 161,
  errorOccurred: 'Ocurrió un error, por favor vuelve a intentar.',
  existingMail: 'El correo electrónico ya se encuentra registrado.'
}
